import * as ordersList from './list'
import * as orderDetails from './details'
import * as createOrders from './create'
import * as refundOrders from './refund'
export default {
    ...ordersList,
    ...orderDetails,
    ...createOrders,
    ...refundOrders
}